import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CashDrawerStaff } from "./CashDrawerStaff";
import type { CashDrawerTotalDTOBase } from "./CashDrawerTotalDTOBase";

export class CashDrawerTotalStaff implements CashDrawerTotalDTOBase {
  constructor(public readonly totalId: number, public readonly reportDate: Date, public readonly startingCashTotalCents: number, public readonly endingCashTotalCents: number | null, public readonly cashSalesCents: number | null, public readonly endingCheckTotalCents: number | null, public readonly checkSalesCents: number | null, public readonly finalizedFlag: boolean, public readonly finalizedOn: Date | null, public readonly finalizedBy: string | null, public readonly createdOn: Date, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly cashDrawer: CashDrawerStaff | null) {
    this.cbiServiceContext = null;
    this.cashDrawerLoaded = this.cashDrawer != null;
    this.cashDrawerCached = this.cashDrawer;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private cashDrawerLoaded: boolean;
  private cashDrawerCached: CashDrawerStaff | null;
  async cashDrawerLazy(): Promise<CashDrawerStaff | null> {
    if (!this.cashDrawerLoaded) {
      this.cashDrawerCached = await this.cbiServiceContext!.cashDrawerService().getCashDrawerTotalStaffCashDrawer(this.totalId);
      this.cashDrawerLoaded = true;
    }
    return this.cashDrawerCached;
  }
  async finalize(): Promise<void> {
    return await this.cbiServiceContext!.cashDrawerService().finalizeStaff({ totalId: this.totalId });
  }
  async saveCount(startingCents: number, endingCents: number, checkCents: number): Promise<void> {
    return await this.cbiServiceContext!.cashDrawerService().saveCountStaff({ total: { totalId: this.totalId }, startingCents: startingCents, endingCents: endingCents, checkCents: checkCents });
  }
  async saveStartingCount(startingCents: number): Promise<void> {
    return await this.cbiServiceContext!.cashDrawerService().saveStartingCountStaff({ total: { totalId: this.totalId }, startingCents: startingCents });
  }
}
